import { AsteriskIcon } from 'lucide-react'
import React from 'react'
import './styles.css'
import clsx from 'clsx'
import { UseFormRegister } from 'react-hook-form'

type Props = React.InputHTMLAttributes<HTMLTextAreaElement> & {
  name: string
  label: string
  textareaSize: 'lg' | 'sm'
  register: UseFormRegister<any> // eslint-disable-line @typescript-eslint/no-explicit-any
}

export default function TextAreaFormField({
  name,
  label,
  textareaSize = 'lg',
  register,
  ...inputHtmlProps
}: Props) {
  const isDisabled = inputHtmlProps.disabled === true

  return (
    <div
      className={clsx(
        'form-field-root',
        textareaSize === 'lg' ? '!h-32' : '!h-20',
        {
          'opacity-50 cursor-not-allowed': isDisabled,
        },
      )}
    >
      <label
        htmlFor={name}
        className="text-themed-grey-500 font-bold select-none pointer-events-none bg-transparent top-2 text-xs"
      >
        <div className="flex flex-row">
          {label}
          {inputHtmlProps.required && (
            <AsteriskIcon className="text-themed-error" size={12} />
          )}
        </div>
      </label>
      <textarea
        className={clsx(
          'resize-none peer bg-opacity-0 h-full w-full !border-none !outline-none self-end text-sm bg-transparent placeholder:text-base-grey-400',
          {
            'cursor-not-allowed': isDisabled,
          },
        )}
        style={{ fontFamily: 'Inter' }}
        {...register(name)}
        {...inputHtmlProps}
      />
    </div>
  )
}
